export default __webpack_public_path__ + "static/media/logo-nanotech-Garden.4585ba2b.png";